
<template>
  <!--话题管理-->
  <div>
    <x-tabula
      apiOrigin="PHP"
      ref="table"
      :dataSource="dataSource"
      rowKey="circle_category_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'topic',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '话题名', options: [], inputType: 'input' },
        { props: ['columns_id'], placeholder: '所属栏目', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        columns_id: undefined,
        create_date: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['neighbour:topic:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['neighbour:topic:delete'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['neighbour:topic:edit'] },
        {
          text: '删除',
          handle: (record) => this.$refs.table.showDeleteConfirm(record, record.community_name),
          rowOptDisHandle: (row) => row.can_delete === 0,
          permi: ['neighbour:topic:delete']
        }
      ],
      columns: [
        { title: '话题名', dataIndex: 'title', align: 'left', width: '' },
        { title: '所属栏目', dataIndex: 'columns_name', align: 'left', width: '' },
        { title: '动态数', dataIndex: 'circle_count', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/circle/topics',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addTopic',
        addTitle: '新增话题',
        editTitle: '修改话题'
      },
      deleteParam: {
        url: '/circle/topics',
        param: {pk_key: 'circle_category_id', pk_val: ''},
        title: '话题',
        key: 'title'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/circle/topics/selectlist',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.columns;
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
